import React, { useEffect, useState } from 'react';
import { components } from '../components';
import { useLocation } from 'react-router-dom';
import { callService } from '../customHook/callService';
import { text } from '../text';
import { theme } from '../constants';

export const LoanOptions: React.FC = () => {
    const { pathname } = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [selectedLoan, setSelectedLoan] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    const loanItems = [
        {
            title: 'LOAN ON SECURITY DEPOSIT',
            image: require('../assets/other/SecurityDeposite.png'),
        },
        {
            title: 'RENT NOW PAY LATER',
            image: require('../assets/other/Rent_ now_pay_later.png'),
        },
        {
            title: 'LOAN FOR OWNERS/ OPERATORS',
            image: require('../assets/other/Loan_for_owner.png'),

        },
    ];

    // const handleImageClick = async (title: string) => {
    //     console.log(`Image clicked: ${title}`);
    //     try {
    //         const res = await callService('Banner', [
    //             {
    //                 param: 'Banner',
    //                 value: title,
    //             },
    //         ]);
    //         setIsModalOpen(true)
    //         // console.log(`✅ CLICK_BANNER triggered for "${title}"`, res);
    //     } catch (error) {
    //         setIsModalOpen(true)
    //         console.error(`❌ CLICK_BANNER failed for "${title}"`, error);
    //     }

    // };

    const handleImageClick = async (title: string) => {
        console.log(`Image clicked: ${title}`);
        try {
            const res = await callService('Banner', [
                {
                    param: 'Banner',
                    value: title,
                },
            ]);
            setSelectedLoan(title);
            setIsModalOpen(true);
        } catch (error) {
            setSelectedLoan(title); // ✅ still show message even on error
            setIsModalOpen2(true);
            // setIsModalOpen(true);
            console.error(`❌ CLICK_BANNER failed for "${title}"`, error);
        }
    };

    return (
        <>
            <components.Header title="Loans" goBack={true} />
            <main className="container">
                <div style={{ marginTop: '10%', marginBottom: 40 }}>
                    {/* <h2 style={{ textAlign: 'center', marginBottom: 20, fontWeight: "600" }}>Choose the Right Loan for You</h2> */}

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>
                        {loanItems.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    border: '1px solid #eee',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                }}
                                onClick={() => handleImageClick(item.title)}
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        borderRadius: '8px',
                                        // marginBottom: 16,
                                        transition: 'transform 0.2s',
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {isModalOpen && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                {/* <img
                                    alt='Success'
                                    src={require('../assets/other/04.png')}
                                    style={{ width: '50%', height: 'auto', marginBottom: 10 }}
                                /> */}
                                {/* <span
                                                                    style={{
                                                                        ...theme.fonts.LeagueSpartan_500Medium,
                                                                        fontSize: 12,
                                                                        color: theme.colors.mainColor,
                                                                    }}
                                                                >
                                                                    Nuton
                                                                </span> */}
                                <img
                                    alt='Success'
                                    // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                                    src={require('../assets/other/check.png')}
                                    style={{ width: '30%', height: 'auto', margin: "30px 0" }}
                                />
                                {/* <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
                                    ✅ Request Sent Successfully
                                </h2> */}
                                <p style={{ textAlign: 'center', marginBottom: 10, lineHeight: "1.6" }}>
                                    Interest Registered for: <div>{selectedLoan}</div>
                                </p>
                                <text.T14
                                    style={{
                                        whiteSpace: 'pre-line',
                                        textAlign: 'center',
                                        marginBottom: 24,
                                    }}
                                >
                                    Thank you! Our team will contact you soon.
                                </text.T14>
                                <div
                                    onClick={() => {
                                        setIsModalOpen(false)
                                    }}
                                    style={{
                                        width: '100%',
                                        color: theme.colors.white,
                                        height: 40,
                                        textAlign: 'center',
                                        fontSize: 14,
                                        borderRadius: 10,
                                        userSelect: 'none',
                                        cursor: 'pointer',
                                        textTransform: 'capitalize',
                                        background: "#000000d1",
                                        fontFamily: 'Lato-Bold',
                                        marginTop: 12, // optional spacing
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    Continue
                                </div>
                            </div>
                            {/* <div className="modal-buttons">
                                                <button
                                                    type="button"
                                                    className="cancel-button"
                                                    onClick={() => setIsModalOpen2(false)}
                                                >
                                                    Thank You
                                                </button>
                
                                            </div> */}
                        </div>
                    </div>
                )}




                {isModalOpen2 && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <img
                                    alt='Success'
                                    src={require('../assets/other/04.png')}
                                    style={{ width: '50%', height: 'auto', marginBottom: 10 }}
                                />
                                {/* <span
                                                                    style={{
                                                                        ...theme.fonts.LeagueSpartan_500Medium,
                                                                        fontSize: 12,
                                                                        color: theme.colors.mainColor,
                                                                    }}
                                                                >
                                                                    Nuton
                                                                </span> */}
                                <img
                                    alt='Success'
                                    // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                                    src={require('../assets/other/warning.png')}
                                    style={{ width: '25%', height: 'auto', margin: "30px 0" }}
                                />
                                <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
                                    Something Went Wrong
                                </h2>
                                <p style={{ textAlign: 'center', marginBottom: 10, lineHeight: "1.6" }}>
                                    We couldn't process your request.
                                </p>
                                <text.T14
                                    style={{
                                        whiteSpace: 'pre-line',
                                        textAlign: 'center',
                                        marginBottom: 24,
                                    }}
                                >
                                    Please try again later. If the issue persists, contact our support team.
                                </text.T14>
                                <div
                                    onClick={() => {
                                        setIsModalOpen2(false)
                                    }}
                                    style={{
                                        width: '100%',
                                        color: theme.colors.white,
                                        height: 40,
                                        textAlign: 'center',
                                        fontSize: 14,
                                        borderRadius: 10,
                                        userSelect: 'none',
                                        cursor: 'pointer',
                                        textTransform: 'capitalize',
                                        background: "#000000d1",
                                        fontFamily: 'Lato-Bold',
                                        marginTop: 12, // optional spacing
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    Continue
                                </div>
                            </div>
                            {/* <div className="modal-buttons">
                                                <button
                                                    type="button"
                                                    className="cancel-button"
                                                    onClick={() => setIsModalOpen2(false)}
                                                >
                                                    Thank You
                                                </button>
                
                                            </div> */}
                        </div>
                    </div>
                )}
            </main>
        </>
    );
};


// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { components } from '../components';

// const termsAndConditions = [
//     {
//         id: 1,
//         title: '1. Acceptance of Terms',
//         content:
//             'By accessing and using our PG booking platform, you agree to comply with and be bound by these Terms and Conditions. If you do not agree with any part of the terms, you must not use our services.',
//     },
//     {
//         id: 2,
//         title: '2. Services Provided',
//         content:
//             'We provide a platform for users to search, compare, and book Paying Guest (PG) accommodations. We are not property owners but facilitate communication and transactions between tenants and PG owners.',
//     },
//     {
//         id: 3,
//         title: '3. User Responsibilities',
//         content:
//             'You agree to provide accurate information during registration and bookings. You are solely responsible for interactions with PG owners and verifying property details before making any commitments.',
//     },
//     {
//         id: 4,
//         title: '4. Booking and Payments',
//         content:
//             'All bookings are subject to availability and confirmation by the PG owner. Payment terms may vary per property and are governed by the agreements between tenants and PG providers.',
//     },
//     {
//         id: 5,
//         title: '5. Cancellation and Refunds',
//         content:
//             'Cancellation policies vary by PG and are displayed at the time of booking. Refunds, if any, are handled according to the respective PG owner’s policy and not by our platform.',
//     },
//     {
//         id: 6,
//         title: '6. Limitation of Liability',
//         content:
//             'We are not liable for any damages, losses, or disputes that arise from interactions or transactions between users and PG owners. We do not guarantee the accuracy or availability of listings.',
//     },
//     {
//         id: 7,
//         title: '7. Modifications to Terms',
//         content:
//             'We reserve the right to modify these Terms and Conditions at any time. Any changes will be effective immediately upon posting on the platform. Continued use of our services constitutes acceptance of those changes.',
//     },
//     {
//         id: 8,
//         title: '8. Termination',
//         content:
//             'We reserve the right to suspend or terminate your access to the platform if you violate these terms or engage in fraudulent or harmful behavior.',
//     },
//     {
//         id: 9,
//         title: '9. Contact Information',
//         content:
//             'For any questions or concerns regarding these Terms and Conditions, please contact us at support@yourpgplatform.com.',
//     },
// ];

// export const LoanOptions: React.FC = () => {
//     const { pathname } = useLocation();

//     useEffect(() => {
//         window.scrollTo(0, 0);
//         document.documentElement.scrollTop = 0;
//     }, [pathname]);

//     const renderHeader = (): JSX.Element => {
//         return <components.Header title="Loan Options" goBack={true} />;
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main className="container" style={{ paddingBottom: 0 }}>
//                 <div style={{ marginTop: '10%', marginBottom: 20 }}>
//                     {termsAndConditions.map((item) => (
//                         <div key={item.id} style={{ marginBottom: '10%' }}>
//                             <text.H5 style={{ marginBottom: 10 }}>{item.title}</text.H5>
//                             <text.T14>{item.content}</text.T14>
//                         </div>
//                     ))}
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>
//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };
